// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'dataviz-column';

export const Component = () => (
  <path d='M1 0v21h21v1H0V0h1Zm11.5 2v17H9V2h3.5Zm6 5v12H15V7h3.5Zm-12 5v7H3v-7h3.5Z' />
);

export const viewBox = '0 0 22 22';
